module.exports = __webpack_public_path__ + "img/6.34e1207a.png";